<template>
    <!-- modal__content -->
    <div class="modal__content modal__content-adddesigns pl30 pr30 pb20">
      <h2 class="text-size-20 text-regular mb20">Let’s give our client some information</h2>
      <div class="border-bottom-lighter pb20">
        <h3 class="text-size-16 text-regular mb5">First design will be live in <span class="text-color-purple text-medium">{{etaValue}} hours</span></h3>
        <range-slider class="mb5" :taskId="args.taskId" :projectId="args.projectId" 
          :value="etaValue" :etaType="'estimatedTimeOfCompletion'">
        </range-slider>
        <div class="flex flex--justify-space-between">
          <span class="text-size-12 text-regular" v-for="count in etaRuler">
            {{count}}
          </span>
        </div>
      </div>
      <div class="border-bottom-lighter pt25 pb20 mb20">
        <h3 class="text-size-16 text-regular mb5">I estimate to spend <span class="text-color-purple text-medium">{{etwValue}} hours</span> on this task</h3>
        <range-slider class="mb5" :taskId="args.taskId" :projectId="args.projectId" 
          :value="etwValue" :etaType="'estimatedWork'">
        </range-slider>
        <div class="flex flex--justify-space-between">
          <span class="text-size-12 text-regular" v-for="count in etwRuler">
            {{count}}
          </span>
        </div>
      </div>
      <button class="btn btn--block text-uppercase mb0" :disabled="btnDisabled" @click="onConfirm()">Start this task</button>
    </div><!-- modal__content END -->
</template>

<script>
import { mapActions } from 'vuex'
import RangeSlider from 'modules/RangeSlider'

export default {
  components: {
    'range-slider': RangeSlider
  },

  data () {
    return {
      etaValue: 0,
      etwValue: 0,
      estimatedTime: 0,
      etaRuler: [0, 12, 24, 36, 48, 60, 72],
      etwRuler: [0, 10, 20, 30, 40, '50+'],
      btnDisabled: false
    }
  },

  props: {
    args: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions([
      'updateStatus'
    ]),

    init () {
      this.bindEvents()
      this.setEta()
    },

    onConfirm () {
      this.updateStatus({ projectId: this.args.projectId, taskId: this.args.taskId, status: 'inProgress' })
      this.btnDisabled = true
      this.$bus.$emit('modalClose')
    },

    bindEvents () {
      this.$bus.$on('updateTaskEtaValue', (taskId, projectId, value, etaType) => {
        if (this.args.taskId == taskId && this.args.projectId == projectId) {
          this.onUpdateEtaValue(value, etaType)
        }
      })
    },

    unbindEvents () {
      this.$bus.$off('updateTaskEtaValue')
      this.$bus.$off('updateTaskEta')      
    },

    setEta () {
      this.etaValue = this.args.etaValue
      this.etwValue = this.args.etwValue
    },

    onUpdateEtaValue (value, etaType) {
      if (etaType === 'estimatedTimeOfCompletion') {
        this.etaValue = value
      } else {
        this.etwValue = value
      }
    }
  },
  created () {
    this.init()
  },

  beforeDestroy () {
    this.unbindEvents()
  }
}
</script>


// WEBPACK FOOTER //
// UpdateStatusModal.vue?10c41232